import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  status: z.enum(["all", "active", "draft", "concluded"]).optional(),
});

export const Route = createFileRoute("/experiments/$id/variants")({
  validateSearch: searchSchema,
});
